import styled from '@emotion/styled';
import { useState } from 'react';
import { Responsive, getResponsiveContentfulImageUrl } from '../../../ui';
import MediaItemDialog from '../../../features/news/media/ui/MediaItemDialog';
import { IAsset } from '../../../contentful';

interface IImageCardProps {
	item: IAsset;
	alt?: string;
	className?: string;
}

export default function ImageCard({
	item,
	alt,
	className,
	...rest
}: IImageCardProps) {
	const isMobile = Responsive.useMatchesBreakpoint('mobileXL');
	const [isDialogOpen, setDialogOpen] = useState(false);

	return (
		<>
			{isDialogOpen && (
				<MediaItemDialog
					setDialogOpen={setDialogOpen}
					isDialogOpen={isDialogOpen}
					item={item}
					displayFilename={false}
					allowDownload={false}
				/>
			)}
			<InvisibleButton
				data-translate
				aria-label={`Open image preview for ${alt}`}
				onClick={() => setDialogOpen(true)}
			>
				<StyledPicture className={className} {...rest}>
					<img
						src={getImageCardSource(item.fields.file.url, isMobile)}
						alt={alt}
					/>
				</StyledPicture>
			</InvisibleButton>
		</>
	);
}

function getImageCardSource(imageSrc: string, isMobile?: boolean) {
	return getResponsiveContentfulImageUrl(imageSrc, {
		fit: 'thumb',
		w: isMobile ? 253 : 486,
		h: isMobile ? 169 : 324,
	});
}

const InvisibleButton = styled.button`
	background: none;
	border: none;
	padding: 0;
	cursor: pointer;
`;

const StyledPicture = styled.picture`
	overflow: hidden;
	border-radius: 16px;
	padding: 0;
	margin: 0;
	width: 100%;
	height: 100%;
	display: inline-block;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		border-radius: 8px;
	}

	img {
		object-fit: cover;
		width: 100%;
		height: 100%;
		padding: 0;
		margin: 0;

		pointer-events: none;
		-webkit-user-drag: none;
	}
`;
